import { Channel } from './channel';

export class ExhaustGasSetting {
    id?: string;
    title: string;
    vesselId: string;
    averageChannel?: string;
    averageChannelData?: Channel;
    settingChannels: ExhaustSetting[];

    constructor(index: number, vesselId: string) {
        this.title = `Cylinder Group ${index + 1}`;
        this.vesselId = vesselId;
        this.settingChannels = [];
        this.averageChannel = null;
    }
}

export class ExhaustSetting {
    id?: string;
    exhaustGasSettingId?: string;
    index: number;
    tempChannel?: string;
    tempChannelData?: Channel;
    deviationChannel?: string;
    deviationChannelData?: Channel;

    constructor(index: number) {
        this.index = index;
        this.tempChannel = null;
        this.deviationChannel = null;
    }
}

export interface ExhaustGasFcu {
    [fcuNum: number]: { GroupNum: number; Grps: ExhaustGasFcuSetting[] };
}

export interface ExhaustGasFcuSetting {
    Num: number;
    ave_chid: number;
    cylinder_chid: number[];
    deviation_chid: number[];
}

export const maxExhaustSettings = 8;
export const maxSettingChannels = 24;
